// Module
var code = "<div ng-controller=\"secureController as secureCtrl\"> <track-inner-viewer></track-inner-viewer> </div> ";
// Exports
module.exports = code;